import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";

/** Five-Year Forecast API (gl-api /forecasts). See saga/forecast.ts for payload shapes. */
export function useForecastApi() {
    const callApi = useApiCall();
    const A = SAGA_ACTIONS.FORECAST;

    return {
        listForecasts: (params: { branch_id?: number; status?: string }, onSuccess: Function, onError: Function) =>
            callApi(A.LIST, params, onSuccess, onError),
        createForecast: (body: any, onSuccess: Function, onError: Function) =>
            callApi(A.CREATE, body, onSuccess, onError),
        getForecast: (forecastId: number, onSuccess: Function, onError: Function) =>
            callApi(A.DETAILS, { forecastId }, onSuccess, onError),
        updateForecast: (forecastId: number, body: any, onSuccess: Function, onError: Function) =>
            callApi(A.UPDATE, { forecastId, body }, onSuccess, onError),
        deleteForecast: (forecastId: number, onSuccess: Function, onError: Function) =>
            callApi(A.DELETE, { forecastId }, onSuccess, onError),
        getCategories: (params: { branch_id?: number }, onSuccess: Function, onError: Function) =>
            callApi(A.CATEGORIES, params, onSuccess, onError),
        addLine: (forecastId: number, body: any, onSuccess: Function, onError: Function) =>
            callApi(A.ADD_LINE, { forecastId, body }, onSuccess, onError),
        updateLine: (forecastId: number, lineId: number, body: any, onSuccess: Function, onError: Function) =>
            callApi(A.UPDATE_LINE, { forecastId, lineId, body }, onSuccess, onError),
        deleteLine: (forecastId: number, lineId: number, onSuccess: Function, onError: Function) =>
            callApi(A.DELETE_LINE, { forecastId, lineId }, onSuccess, onError),
        saveMonthlyValues: (forecastId: number, lineId: number, values: { month_index: number; amount: number | null }[],
                            onSuccess: Function, onError: Function) =>
            callApi(A.SAVE_MONTHLY_VALUES, { forecastId, lineId, values }, onSuccess, onError),
        getResults: (forecastId: number, onSuccess: Function, onError: Function) =>
            callApi(A.RESULTS, { forecastId }, onSuccess, onError),
    };
}
